import React, {useMemo} from 'react';
import {useAllApps} from '../../hooks/useApps';
import {getCookieValue} from '../../helpers/getCookie';
import {useQuery} from 'react-query';
import {fetchCardAnalysis} from '../../requests/queries/verifications';
import {getFlows} from './utils';
import {OverviewCards} from '../../components/OverviewCards';

export const OverviewAnalytics = ({cardData = [], isLoading, filterParams}) => {
  const {appIds, isLoading: appsLoading} = useAllApps();

  const formatValue = value => new Intl.NumberFormat('en-US').format(value);

  const env = getCookieValue('env');
  const envData = env === 'Live' ? 'production' : env;
  const apps =
    filterParams?.app_ids?.length > 0
      ? filterParams?.app_ids?.join(',')
      : appIds?.join(',');
  const params = useMemo(() => {
    const baseParams = {
      app_ids: apps,
      environment: envData?.toLowerCase(),
    };

    if (filterParams?.status) {
      baseParams.status = filterParams.status;
    }
    if (filterParams?.term?.length > 0) {
      baseParams.term = filterParams.term;
    }
    if (filterParams?.type) {
      baseParams.type = filterParams.type.join(',');
    }
    if (filterParams?.mode) {
      baseParams.mode = filterParams.mode.join(',');
    }
    if (filterParams?.dateRange) {
      baseParams.start = filterParams.dateRange.start;
      baseParams.end = filterParams.dateRange.end;
    }

    return baseParams;
  }, [
    apps,
    envData,
    filterParams?.dateRange,
    filterParams?.mode,
    filterParams?.status,
    filterParams?.type,
    filterParams?.term,
  ]);

  const {data, isLoading: statsLoading} = useQuery(
    ['verification-analysis', {...params}],
    () => fetchCardAnalysis({params}),
    {enabled: Boolean(!appsLoading && appIds && cardData?.length === 0)},
  );

  const ANALYSIS_DATA = useMemo(
    () => (!statsLoading && data?.data ? data?.data : []),
    [data?.data, statsLoading],
  );

  const CARDS = getFlows(ANALYSIS_DATA?.cards);
  const columnsLength = cardData?.length || CARDS?.length;
  const allCardData = cardData?.length > 0 ? cardData : CARDS;

  return (
    <OverviewCards
      cardData={allCardData}
      overviewLoading={statsLoading || isLoading}
      className={`grid md:grid-cols-${
        columnsLength > 3 ? columnsLength - 1 : 3
      } xl:grid-cols-${columnsLength} gap-2 lg:gap-4 flex-wrap my-5`}
      formatValue={formatValue}
    />
  );
};
